import { useQuery } from '@tanstack/react-query';
import printerApiRequestService from '../../service/printerApiRequests/apiService';
import { useAppSelector } from '../../store/store';
import { useAuth } from '../../component/context/AuthContext/AuthContext';

const getLaserPrintersEndpoint = '/jetstream/api/1/getlaserprinters';

const usePrinterApi = (_queryParams: string, printerType: string) => {
  const { userData } = useAuth();
  const url = getLaserPrintersEndpoint;

  const { selectStationData } = useAppSelector(
    (state) => state.appStateReducer,
  );

  return useQuery({
    queryKey: [url, selectStationData, printerType, userData?.access_token],
    queryFn: () =>
      printerApiRequestService(
        url,
        selectStationData as string,
        printerType,
        userData?.access_token,
      ),
    enabled: false,
    retry: 3,
  });
};

export default usePrinterApi;
